import React from "react";
import type { StockPileRow } from "@services/drybulkCargoOperationsApi";
import PartyGrid from "./PartyGrid";

/** DBCO-0029 (R-46) - the S.Pile grid; a company that is also a Shipper appears here as well. */
const StockPilesGrid: React.FC<{ stockPiles: StockPileRow[]; onOpen: (code: string) => void }> = ({
  stockPiles,
  onOpen,
}) => (
  <PartyGrid
    langKey="stock-piles-grid"
    testId="stock-piles-grid"
    rows={stockPiles.map((row) => ({
      code: row.stockPileCode,
      planned: row.planned,
      actual: row.actual,
      splits: row.splits,
    }))}
    onOpen={onOpen}
  />
);

export default StockPilesGrid;
